<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <div class="list-row">
    <v-card
        class="clickable"
    >
      <v-row>
        <v-col class="pl-5"
               @click="openCustomer({customer:customer,customers:$store.state.customers.data,index:currentIndex})"
        >

          <v-btn :loading="toggle_start_loading" class="mr-4" style="min-width: 20px;padding:0;position: relative"
                 text @click.stop="ToggleStar()">
            <v-icon v-if="customer.stars && customer.stars.length >0" class="yellow--text"
                    large
                    style="position: absolute;top:0;left:0">
              mdi-star
            </v-icon>
            <v-icon large>
              mdi-star-outline
            </v-icon>
          </v-btn>
          <span v-if="
                  customer.status===CustomerConst.STATUS_SUBMITTED_PENDING_SYNC ||
                  customer.status===CustomerConst.STATUS_SYNCED_PENDING_ACTIVE"
          >(รออนุมัติ)</span>
          <span v-if="
                  customer.status===CustomerConst.STATUS_REJECTED"
          >(ไม่อนุมัติ)</span>
          <span v-if="
                  customer.status===CustomerConst.STATUS_NOT_USE"
          >(ไม่ใช้แล้ว)</span>
          <span>
          {{ customer.nickname }}
          <small>
            {{ customer.province }}
            <span v-if=" customer.status===CustomerConst.STATUS_REJECTED" class="ml-1 red pa-1"
                  style="color: white">{{ customer.erp_remark1 }}</span>
            </small>
             <small v-if=" customer.debit_invoice>0" class="caption">
            <span class="ml-1 red pa-1" style="color: white"
            >ค้างจ่าย {{ $helper.number_format(customer.debit_invoice, 0) }}</span>
             </small>

            <small v-if="!customer.gis_is_confirm" class="caption">
            <span class="ml-1 red pa-1" style="color: white;word-break: keep-all"
            >ที่อยู่ยังไม่ยืนยัน</span>
          </small>
          <small v-if="customer.loyalty_balance>0">
            <span class="ml-1 pa-1 orange--text"
            >   <v-icon small color="orange">mdi-star</v-icon>{{ $helper.number_format(customer.loyalty_balance, 0)  }}</span>
          </small>
          </span>

        </v-col>

        <v-col v-if="customer.last_order_at" class="col-2 text-right d-none d-md-inline"
               @click="$store.commit('dialog_is_customer',{toggle:true,index:currentIndex})">
          {{ customer.last_order_at ? $helper.date_format_short(customer.last_order_at) : '' }}
        </v-col>


        <v-col v-if="$store.state.carts.current_customer_map[customer.id]" class="col-2 col-md-1 text-right"
               @click="onClickCart(customer)">

          <v-icon large>mdi-cart</v-icon>

          <v-badge bottom color="green" offset-x="16px" offset-y="8px" overlap right>
            <template v-slot:badge>
              {{ $store.state.carts.current_customer_map[customer.id].items.length }}
            </template>
          </v-badge>

        </v-col>
        <v-col v-else class="pr-5 col-2 col-md-1 text-right" @click="onClickCart(customer)">
          <v-icon large style="opacity: 0.5">mdi-cart-outline</v-icon>
        </v-col>

      </v-row>
    </v-card>
  </div>

</template>
<style lang="scss" scoped>

</style>

<script lang="ts">

import {Component, Prop, Vue} from 'vue-property-decorator'
import {Customer, CustomerConst} from '../../models/Customer'
import router from '../../router'

@Component({
  components: {}
})
export default class CustomerRow extends Vue {
  @Prop() customer: Customer
  @Prop() currentIndex: number

  CustomerConst = CustomerConst
  toggle_start_loading = false

  async onClickCart(customer: Customer) {
    if (
        customer.status == CustomerConst.STATUS_SUBMITTED_PENDING_SYNC ||
        customer.status == CustomerConst.STATUS_SYNCED_PENDING_ACTIVE) {
      this.$root.$emit('onWarning', {message: 'ลูกค้าไม่สามารถสั่งสินค้าได้ รอส่วนกลางอนุมัติบัญชี'})
      return
    }
    if (
        customer.status == CustomerConst.STATUS_REJECTED) {
      this.$root.$emit('onWarning', {message: 'ลูกค้าสถานะไม่อนุมัติ ไม่สามารถสั่งสินค้าได้'})
      return
    }

    if (
        customer.status == CustomerConst.STATUS_NOT_USE) {
      this.$root.$emit('onWarning', {message: 'ลูกค้าสถานะไม่ใช้แล้ว ไม่สามารถสั่งสินค้าได้'})
      return
    }

    if (
        customer.business_type == '') {
      this.$root.$emit('onWarning', {message: 'ลูกค้าไม่มีกลุ่มธุรกิจ ติดต่อฝ่ายบัญชี'})
      return
    }

    if (
        !this.customer.gis_is_confirm) {
      this.$root.$emit('onWarning', {message: 'ลูกค้าไม่ได้ยืนยันพิกัดไม่สามารถสั่งของได้'})
      return
    }

    // Check if customer has enough loyalty points to offer point order option
    if (customer.loyalty_balance && customer.loyalty_balance > 500) {
      this.$root.$emit('openOrderTypeChooser', {
        loyaltyBalance: customer.loyalty_balance,
        onApply: async (orderType: 'money' | 'point') => {
          await this.createCart(customer, orderType)
        }
      })
    } else {
      // Default to money order if insufficient points
      await this.createCart(customer, 'money')
    }
  }

  async createCart(customer: Customer, payBy: 'money' | 'point' = 'money') {
    // this.tabs_cart.isLoad = true
    var order = await this.$store.dispatch('init_cart', customer)//.then((cart: Order) => {
    // this.tabs_cart.isLoad = false
    if (order instanceof Error) {
      const e: any = order
      console.log(e.response.data)
      if (e.response && e.response.data && e.response.data.message)
        this.$root.$emit('onWarning', {message: e.response.data.message, error: e})
      else
        this.$root.$emit('onError', {error: e})
      return
    }

    // Set pay_by based on user choice
    if (payBy === 'point') {
      order.pay_by = 'point'
      order.credit_term = 0
      await this.$store.dispatch('set_order', order)
    }

    this.$store.commit('dialog_is_customer', {toggle: false})
    router.push('/cart')
    // })
  }

  async ToggleStar() {
    const customer: Customer = Object.setPrototypeOf(this.customer, Customer.prototype)
    const current_star = customer.stars && customer.stars.length > 0
    this.toggle_start_loading = true
    await customer.SetStar(!current_star)
    this.toggle_start_loading = false
    if (current_star) {
      customer.stars.pop()
    } else {
      customer.stars.push({id: 0})
    }
  }

  openCustomer(option) {
    this.$root.$emit('openCustomer', option)
  }
}

</script>
